import { defineStore } from 'pinia'
import { Setting as SystemSetting } from '@/api/system/setting.ts'
import { getDayjs, isBoolean, isNumber } from '@/common/utils/common'

export type Setting = {
    name?: string
    code?: string
    value?: any
    description?: string
}

const getExpiresIn = () => {
    return getDayjs().add(1, 'hour').valueOf()
}

const getSettings = async (noCacheCodes: string[]): Promise<Setting[]> => {
    const settings: Setting[] = []
    const result = await SystemSetting.list({
        codeList: noCacheCodes,
    })
    result.data
        ?.filter(item => item.code && noCacheCodes.includes(item.code))
        .forEach(item => {
            const value = item.value
            let value2: any = undefined
            if (value) {
                value2 = isBoolean(value) ? Boolean(value) : isNumber(value) ? Number.parseFloat(value) : value
            }
            const dic: Setting = {
                name: item.name,
                code: item.code,
                value: value2,
            }
            settings.push(dic)
        })
    return settings
}

type SettingState = {
    map: Record<
        string,
        {
            expiresIn: number
            setting: Setting
        }
    >
}

export const useSettingStore = defineStore('setting', {
    state: (): SettingState => {
        return {
            map: {},
        }
    },
    actions: {
        /**
         * 远程或从缓存获取
         * @param codeList
         */
        async mapSettings(codeList: string[]): Promise<Record<string, Setting>> {
            return await this.pull(codeList)
        },
        // async mapSettingsValue(codeList: string[]): Promise<Record<string, any>> {
        //     const finalMap: Record<string, any> = {}
        //     const map = await this.mapSettings(codeList)
        //     Object.keys(map).forEach(key => {
        //         finalMap[key] = map[key].value
        //     })
        //     return finalMap
        // },
        // async getSettingByCode(code: string): Promise<Setting> {
        //     return (await this.mapSettings([code]))?.[code]
        // },
        // async getSettingByCodeList(codeList: string[]): Promise<Setting[]> {
        //     const finalArray: Setting[] = []
        //     const map = await this.mapSettings(codeList)
        //     Object.keys(map).forEach(key => {
        //         if (codeList.includes(key)) {
        //             finalArray.push(map[key])
        //         }
        //     })
        //     return finalArray
        // },
        // async getSettingValueByCode(code: string): Promise<any> {
        //     return (await this.mapSettings([code]))?.[code]?.value
        // },
        push(settings: Setting[]): void {
            this.expires()
            for (const index in settings) {
                const setting = settings[index]
                if (setting.code && setting.code !== '') {
                    const settingMap = this.map[setting.code]
                    if (!settingMap) {
                        this.map[setting.code] = {
                            expiresIn: getExpiresIn(),
                            setting: setting,
                        }
                    }
                }
            }
        },
        pop(code: string): void {
            delete this.map[code]
        },
        async pull(codeList: string[]): Promise<Record<string, Setting>> {
            this.expires()
            const finalMap: Record<string, Setting> = {}
            const noCacheCodeList: string[] = []
            codeList.forEach(code => {
                const tempSetting = this.map[code]
                if (tempSetting) {
                    finalMap[code] = tempSetting.setting
                } else {
                    noCacheCodeList.push(code)
                }
            })
            if (noCacheCodeList.length === 0) {
                return finalMap
            }

            const remoteSettings = await getSettings(noCacheCodeList)
            noCacheCodeList.forEach(noCacheCode => {
                const any = remoteSettings.filter(item => item.code === noCacheCode)
                if (!any || any.length <= 0) {
                    remoteSettings.push({
                        name: '',
                        code: noCacheCode,
                        value: '',
                    })
                }
            })
            this.push(remoteSettings)
            noCacheCodeList.forEach(noCode => {
                const tempSetting = this.map[noCode]
                if (tempSetting) {
                    finalMap[noCode] = tempSetting.setting
                } else {
                    finalMap[noCode] = {
                        name: '',
                        code: noCode,
                        value: '',
                    }
                }
            })
            // console.log(finalMap)
            return finalMap
        },
        expires(): void {
            if (this.map) {
                for (const code in this.map) {
                    const isExpires = getDayjs().isAfter(this.map[code].expiresIn)
                    if (isExpires) {
                        this.pop(code)
                    }
                }
            }
        },
        reset(): void {
            this.$reset()
        },
        clear() {
            sessionStorage.removeItem('setting')
        }
    },
    persist: {
        storage: sessionStorage,
    },
})
